import { IUpdateChecklistMaquinaEquipItensUseCase } from "../../../../controledePatrimonio/presentation/useCases/update/update_checklist_maquina_equip_itenss_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * UpdateChecklistMaquinaEquipItensUseCase
 */

export class UpdateChecklistMaquinaEquipItensUseCase implements IUpdateChecklistMaquinaEquipItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    idChecklistMaquinaEquipItem: number,
    ordem?: string,
    descricao?: string,
  ): Promise<void> {
    await this.repository.updateChecklistMaquinaEquipItem(
      idChecklistMaquinaEquipItem,
      ordem,
      descricao,
    );
  }
}
